import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import api from "../../../services/api";

const SetPaystackUnitPrice = () => {
  const [smsPrice, setSMSPrice] = useState("");
  const [voicePrice, setVoicePrice] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    setIsFetching(true)
    api.admin.getPaystackUnitPrice('sms')
      .then((res) => {
        setSMSPrice(res.data['SMS-UNIT-PRICE-IN-NAIRA'][0].value);
      })
      .catch((err) => {
        toast.error("Failed to get Unit Price.");
        console.error("Error getting Unit Price:", err);
      })
      .finally(() => {
        setIsFetching(false);
      });
    api.admin.getPaystackUnitPrice('voice')
      .then((res) => {
        setVoicePrice(res.data['VOICE-UNIT-PRICE-NAIRA'][0].value);
      })
      .catch((err) => {
        toast.error("Failed to get Unit Price.");
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [])

  const handleSMS = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("price", smsPrice);

    api.admin.setPaystackUnitPrice('sms', formData)
      .then((res) => {
        toast.success(res.data?.message);
      })
      .catch((err) => {
        toast.error("Failed to update Unit Price.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleVoice = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("price", voicePrice);

    api.admin.setPaystackUnitPrice('voice', formData)
      .then((res) => {
        console.log(res)
        toast.success("Unit Price updated successfully!");
      })
      .catch((err) => {
        toast.error("Failed to update Unit Price.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className='flex flex-col gap-4'>
      <Box
        component="form"
        onSubmit={handleSMS}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 400,
          margin: "0 auto",
          padding: 2,
          boxShadow: 3,
          borderRadius: 1,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          Set Naira Unit Price (SMS)
        </Typography>
        {isFetching ? <CircularProgress /> : <TextField
          label="Unit Price"
          variant="outlined"
          name="price"
          value={smsPrice}
          onChange={(e) => setSMSPrice(e.target.value)}
          fullWidth
          required
          sx={{ marginBottom: 2 }}
        />}
        <Button type="submit" variant="contained" color="primary" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Submit"}
        </Button>
      </Box>
      <Box
        component="form"
        onSubmit={handleVoice}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 400,
          margin: "0 auto",
          padding: 2,
          boxShadow: 3,
          borderRadius: 1,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          Set Naira Unit Price (Voice)
        </Typography>
        {isFetching ? <CircularProgress /> : <TextField
          label="Unit Price"
          variant="outlined"
          name="voice"
          value={voicePrice}
          onChange={(e) => setVoicePrice(e.target.value)}
          fullWidth
          required
          sx={{ marginBottom: 2 }}
        />}
        <Button type="submit" variant="contained" color="primary" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Submit"}
        </Button>
      </Box>
    </div>
  );
};

export default SetPaystackUnitPrice